import { Link } from "react-router-dom";
import { useState } from 'react'
import ReactCurvedText from 'react-curved-text'
// import ModalVideo from 'react-modal-video'

export default function About() {
    const [isOpen, setOpen] = useState(false);

    return (
        <>
            <section id="about" className="about-1-section pt-0">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-1-image-wrap">
                                <div className="about-1-shape-1">
                                    <img src="assets/images/shape/pattern-1.png" alt="" />
                                </div>
                                <div className="about-1-shape-2">
                                    <img src="assets/images/shape/pattern-1.png" alt="" />
                                </div>
                                <div className="about-1-image-1">
                                    <img src="assets/images/AboutImages/about-4.jpg" alt="About Us Image" />
                                </div>
                                <div className="about-1-video-area" data-parallax='{"y": 30}'>
                                    <div className="about-1-video-btn">
                                        <a onClick={() => setOpen(true)} className="overlay-link play-now ripple" data-fancybox="video-1">
                                            <i className="icon-9"></i>
                                        </a>
                                    </div>
                                    <p className="about-1-video-title">Watch Exclusive <br /> Video</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="section_heading mb_20">
                                <span className="section_heading_title_small">About Sha Care</span>
                                <h2 className="section_heading_title_big">Learn About Our <br /> <span>Sha Care</span> Professional <br /> Senior Care <span>Agency</span></h2>
                            </div>
                            <p className="aboout-1-desc">
                            Sha Car Supports is a registered NDIS provider. Sha Care  takes pride in its ability to connect the individuals We assist with staff members who share similar values, fostering a strong rapport. Our team of approachable support workers is committed to delivering exceptional person-centered care to our participants. The Sha Care Supports service boasts a diverse group of highly qualified professionals, including registered nurses (RN), assistant in nursing (AIN), enrolled nurses (EN), and several staff members trained in the use of hoists. Our employees provide a secure and nurturing environment, allowing NDIS participants to feel at comfortable as they progress at their own pace and achieve lasting personal growth.
                            </p>
                            <ul className="about-1-list">
                                <li>Values-Based Matching: We connect participants with support workers who share their values for genuine, lasting rapport.</li>
                                <li>Qualified & Diverse Team: Our team includes RNs, ENs, AINs, and hoist-trained staff delivering expert care.</li>
                                <li>Safe, Person-Centered Support: We create a nurturing environment where participants grow at their own pace.</li>
                            </ul>
                            <div className="about-1-btn">
                                {/* <Link to="#contact" className="btn-1">Read More<span></span></Link>  Updated to navigate within the page */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ModalVideo (Uncomment if you want the video modal functionality) */}
            {/* <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="vfhzo499OeA" onClose={() => setOpen(false)} /> */}
        </>
    );
}
